import { PureComponent } from 'react';
import Html from 'Component/Html';
import './CategorySeo.style';

export default class CategorySeo extends PureComponent {
    render() {
        const { seoText } = this.props;

        if (!seoText) {
            return null;
        }

        return (
            <div block="CategoryDescription">
                <Html content={ seoText } />
            </div>
        );
    }
}
